<template>
  <div>
    <b-button
      class="brand-icon text-center p-0 h-25 mb-3 text-color"
      variant="outline-secondary"
      block
      @click="askCustInfo"
      :disabled="paymentBntDisabled"
      id="pay-method-phonepe"
    >
      <img
        v-if="state.system.theme == 'theme-light'"
        src="@/assets/images/phonepe_light.png"
        width="100px"
      />
      <img
        v-if="state.system.theme == 'theme-dark'"
        src="@/assets/images/phonepe_dark.png"
        width="100px"
      />
    </b-button>
    <b-modal
      id="phonepe-modal"
      ref="phonepe-modal"
      hide-footer
      hide-header
      centered
      size="sm"
      no-close-on-backdrop
      no-close-on-esc
      @hide="closeModal"
    >
      <header>
        <b-row>
          <b-col :md="request == false ? '10' : '12'">
            <h6 v-if="status.value == false">PhonePe Payment</h6>
            <h6
              class="mb-0 text-success d-flex align-items-center"
              v-if="status.value == true && status.type == 'success'"
            >
              <img src="@/assets/images/success.svg" class="mr-1" alt />
              <span v-if="!$loading" class="ml-1"
                >PhonePe Payment Successful</span
              >
              <span v-if="$loading" class="ml-1">Processing Payment</span>
            </h6>
            <b-progress
              :value="100"
              variant="primary"
              striped
              animated
              class="mt-3"
              v-if="
                status.value == true && status.type == 'success' && $loading
              "
            ></b-progress>
            <b-row
              v-if="
                status.value == true && status.type == 'success' && !$loading
              "
            >
              <b-col md="12" class="mt-3">
                <b-button
                  @click="closeModal"
                  class="w-100"
                  id="phonepe-done-btn"
                  >Done</b-button
                >
              </b-col>
            </b-row>
            <div
              v-if="
                status.value == true &&
                  status.type != 'success' &&
                  status.type != 'PAYMENT_ALREADY_COMPLETED'
              "
            >
              <h6 class="mb-0 d-flex align-items-center">
                <img src="@/assets/images/alert.svg" class="mr-2" alt />
                <span v-if="status.type == 'fail'" class="ml-1"
                  >Payment Failed</span
                >
                <span v-if="status.type == 'cancel'" class="ml-1"
                  >PhonePe Payment Cancelled</span
                >
              </h6>
              <p class="mt-3" v-text="error_message"></p>
            </div>
            <div
              v-if="
                status.value == true &&
                  status.type == 'PAYMENT_ALREADY_COMPLETED'
              "
            >
              <h6 class="mb-3 text-success d-flex align-items-center">
                <img src="@/assets/images/success.svg" class="mr-1" alt />
                <span v-if="!$loading" class="ml-1"
                  >PhonePe Payment Successful</span
                >
                <span v-if="$loading" class="ml-1">Processing Payment</span>
              </h6>
              <p v-if="!$loading">
                Transaction you're trying to cancel is already completed. Press
                continue to save this payment
              </p>
              <b-button
                v-if="!$loading"
                @click="checkStatusPhonepe"
                class="w-100"
                id="phonepe-cont-btn"
                >Continue</b-button
              >
              <b-progress
                :value="100"
                variant="primary"
                striped
                animated
                class="mt-3"
                v-if="$loading"
              ></b-progress>
            </div>
          </b-col>
          <b-col md="2" v-if="request == false">
            <font-awesome-icon
              style="cursor:pointer"
              @click="closeModal"
              class="float-right"
              :icon="['fas', 'times']"
            />
          </b-col>
        </b-row>
      </header>

      <b-row v-if="request == false">
        <b-col md="12">
          <label for="mobile">Confirm PhonePe number</label>
        </b-col>
        <b-col md="12" class="mb-3">
          <b-input-group>
            <template v-slot:append>
              <b-input-group-text :class="clear_mobile" @click="clearMobile">
                <font-awesome-icon
                  :icon="['fas', 'times']"
                  class="f-awesome"
                  v-if="mobile != ''"
                />
              </b-input-group-text>
            </template>
            <b-form-input
              class="phonepe-input-mobile"
              @focus="clear_mobile = 'focus-mobile'"
              @blur="clear_mobile = 'blur-mobile'"
              type="number"
              v-model="mobile"
              placeholder="Enter PhonePe Number"
              v-allow.phone.number
              ref="mobile-input"
            />
          </b-input-group>
        </b-col>
        <b-col offset-md="4">
          <b-button
            variant="primary"
            class="w-100"
            @click="sendRequest"
            :disabled="$loading"
            id="phonepe-send-request"
          >
            <span v-if="!$loading || btnName != 'send request'"
              >Send Request</span
            >
            <b-spinner
              small
              v-if="$loading && btnName == 'send request'"
            ></b-spinner>
          </b-button>
        </b-col>
      </b-row>

      <transition name="fadeHeight" mode="out-in">
        <div class="info-text mt-4" v-if="status.value == false && request">
          <p>
            Payment request sent successfully to the PhonePe account linked to
            {{ mobile }}.
          </p>
          <p>Please ask the customer to initiate payment.</p>
          <div class="text-center mt-4" v-if="countdown != 1">
            <CircularCountDownTimer
              ref="countDown"
              :initial-value="initalTimerValue"
              :stroke-width="2"
              :seconds-stroke-color="'#c0c0c0'"
              :underneath-stroke-color="'#fff'"
              :seconds-fill-color="'#fff'"
              :size="185"
              :padding="14"
              :second-label="'Remaining'"
              :show-second="true"
              :show-minute="false"
              :show-hour="false"
              :show-negatives="false"
              :notify-every="'second'"
              @update="updated"
              @finish="finished"
            ></CircularCountDownTimer>
          </div>
        </div>
      </transition>
      <b-row>
        <b-col md="12" v-if="status.value == true && status.type == 'cancel'">
          <b-button
            class="mt-2 btn-danger w-100"
            @click="closeModal"
            id="phonepe-close-modal"
            >Close</b-button
          >
        </b-col>
        <b-col
          :md="status.value == false && request ? '6' : '12'"
          v-if="
            (request && status.type == 'fail') || (request && status.type == '')
          "
          class="text-center"
        >
          <b-button
            class="mt-2 btn-danger w-100"
            @click="cancelConfimation"
            :disabled="$loading"
            id="phonepe-cancel-conf-btn"
          >
            <span v-if="!$loading || btnName != 'cancel'">Cancel</span>
            <b-spinner small v-if="$loading && btnName == 'cancel'"></b-spinner>
          </b-button>
        </b-col>
        <b-col md="6" class="pl-0" v-if="status.value == false && request">
          <b-button
            class="mt-2 w-100 grey-btn btn-secondary"
            :disabled="statusDisable || $loading"
            @click="checkStatus"
            id="phonepe-checkstatus"
          >
            <span
              v-if="!$loading || btnName != 'check status'"
              v-text="statusBtnName"
            ></span>
            <b-spinner
              small
              v-if="$loading && btnName == 'check status'"
            ></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      size="sm"
      ref="cancel-confirmation"
    >
      <b-row>
        <b-col md="12">
          <p>Are you sure you want to cancel this transaction?</p>
        </b-col>
        <b-col md="6">
          <b-button
            class=""
            block
            @click="$refs['cancel-confirmation'].hide()"
            id="conf-btn-no"
          >
            No
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            class="confirm-btn"
            variant="danger"
            block
            @click="cancelRequest('pop')"
            id="conf-btn-yes"
            >Yes</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
// import db from "../database";
import CircularCountDownTimer from "../components/CircularCountDownTimer";
import * as msg from "../message";

export default {
  name: "phone-pe",
  components: { CircularCountDownTimer },
  props: { amount: String },
  data() {
    return {
      mobile: "",
      clear_mobile: "blur-mobile",
      request: false,
      phonepeData: "",
      btnName: "",
      status: {
        type: "",
        value: false,
      },
      response: "",
      error_message: "",
      initalTimerValue: 185,
      countdown: 0,
      // statusCountDown: 0,
      // fixedTime: 40,
      statusDisable: true,
      statusBtnName: "15s",
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    phonepeDetails() {
      return this.$store.getters["sessions/phonepeDetails"];
    },
    paymentBntDisabled() {
      let check = false;
      if (this.state.system.isOffline) {
        check = true;
      } else if (
        parseFloat(this.amount) > this.state.billing.billing.total_payable
      ) {
        check = true;
      } else if (parseFloat(this.amount) < 0 || parseFloat(this.amount) == 0) {
        check = true;
      } else if (parseInt(this.amount) < 0) {
        check = true;
      } else if (this.amount == "") {
        check = true;
      }
      return check;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1 &&
        this.state.system.isOffline == false
      ) {
        check = true;
      }
      return check;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    checkLayByAmt() {
      let layByAmt = this.state.billing.billing.layBy_Amt;
      if (this.state.billing.billing.layBy_Amt > 0) {
        if (this.state.billing.billing.order.data != "") {
          if (
            this.state.billing.billing.order.summary.amount_due != "0" &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "sales"
          ) {
            layByAmt = "";
          } else if (
            this.state.billing.billing.total_payable !=
              this.state.billing.billing.layBy_Amt &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "lay_by"
          ) {
            layByAmt = "";
          }
        }
      }
      return layByAmt;
    },
  },
  // watch: {
  //   request() {
  //     if (this.statusCountDown >= 0) {
  //       this.countDown();
  //     }
  //   },
  //   statusDisable() {
  //     if (this.statusCountDown >= 0 && this.statusDisable) {
  //       this.countDown();
  //     }
  //   }
  // },
  methods: {
    checkStatus() {
      if (
        (this.countdown < 95 && this.countdown > 80) ||
        (this.countdown < 50 && this.countdown > 35)
      ) {
        this.checkStatusPhonepe();
      } else {
        this.checkStatusZwing();
      }
    },
    cancelConfimation() {
      if (this.status.value == false) {
        this.$refs["cancel-confirmation"].show();
      } else {
        this.cancelRequest("cancel");
      }
    },
    askCustInfo() {
      console.log(this.amount);
      this.request = false;
      this.phonepeData = "";
      this.error_message = "";
      this.countdown = 0;
      this.statusDisable = true;
      this.statusBtnName = "15s";
      this.$store.commit("system/clearPhonepeTransactionId");
      this.status = {
        value: false,
        type: "",
      };
      // this.statusCountDown = 0;
      // this.statusDisable = true;
      if (this.state.billing.billing.customer.data.hasOwnProperty("mobile")) {
        this.mobile = this.state.billing.billing.customer.data.mobile;
      } else {
        this.mobile = "";
      }
      this.$refs["phonepe-modal"].show();
    },
    sendRequest() {
      this.btnName = "send request";
      this.$loading = true;
      let postData = {
        url: "/payment-integration/charge-request",
        merchantOrderId: this.state.billing.billing.order.data.order_id,
        amount: this.amount * 100,
        amount_in_rupee: this.amount,
        mobile: this.mobile,
        name: "rajat",
        email: "rajat.g@gsl.in",
      };
      let data = Object.assign(postData, this.phonepeDetails);
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status != "fail") {
            this.phonepeData = res.data.data.data;
            this.request = true;
            this.$store.commit(
              "system/setPhonepeTransactionId",
              this.phonepeData.transactionId
            );
            // this.statusCountDown = this.fixedTime;
          } else {
            this.alertData(res.data.message, "danger");
            this.closeModal();
          }
          this.alertData(
            res.data.data.message,
            res.data.data.success == true ? "success" : "danger"
          );
          this.btnName = "";
          this.$loading = false;
        })
        .catch(() => {
          this.btnName = "";
          this.$loading = false;
        });
    },
    cancelRequest(from) {
      if (from == "pop") {
        this.$refs["cancel-confirmation"].hide();
      }
      this.btnName = "cancel";
      this.$loading = true;
      let postData = {
        url: "/payment-integration/cancel-payment",
        transactionId: this.phonepeData.transactionId,
      };
      let data = Object.assign(postData, this.phonepeDetails);
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          this.btnName = "";
          if (res.data.data.code == "SUCCESS") {
            if (from == "pop") {
              this.status = {
                value: true,
                type: "cancel",
              };
            } else if (from == "cancel") {
              this.closeModal();
              this.alertData("Transaction cancelled sucessfully!", "success");
            }
            this.error_message = msg.PHONEPE_MSG.CANCELLED;
          } else if (res.data.data.code == "PAYMENT_ALREADY_COMPLETED") {
            this.status = {
              value: true,
              type: "PAYMENT_ALREADY_COMPLETED",
            };
            this.response = res.data.data;
          } else if (res.data.data.code == "AUTHORIZATION_FAILED") {
            this.alertData(
              "Check with internal technical team(AUTHORIZATION_FAILED)",
              "danger"
            );
          } else {
            this.alertData(res.data.data.message, "danger");
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    checkStatusZwing() {
      this.$loading = true;
      // this.statusDisable = true;
      this.btnName = "check status";
      let url =
        "/payment-integration/get-transaction?v_id=" +
        this.phonepeDetails.v_id +
        "&transactionId=" +
        this.phonepeData.transactionId;

      // let data = Object.assign(postData, this.phonepeDetails);
      axios
        .get(url)
        .then((res) => {
          let code = res.data.data.code;
          this.$loading = false;
          // this.statusCountDown = this.fixedTime;
          if (code == null || code == "PAYMENT_PENDING") {
            this.alertData(msg.PHONEPE_MSG.PENDING, "success");
          } else if (code == "PAYMENT_SUCCESS") {
            this.status = { value: true, type: "success" };
            this.makePayment(res.data.data, "zwing", "success");
          } else if (
            code == "PAYMENT_DECLINED" ||
            code == "PAYMENT_CANCELLED" ||
            code == "PAYMENT_FAILED" ||
            code == "PAYMENT_ERROR"
          ) {
            if (code == "PAYMENT_DECLINED") {
              this.error_message = msg.PHONEPE_MSG.DECLINED;
            } else if (code == "PAYMENT_CANCELLED") {
              this.error_message = msg.PHONEPE_MSG.CANCELLED;
            } else if (code == "PAYMENT_FAILED" || code == "PAYMENT_ERROR") {
              this.error_message =
                msg.PHONEPE_MSG.SERVER_ERROR + "(" + code + ")";
            }
            this.makePayment(res.data.data, "zwing", "error");
            this.status = { value: true, type: "cancel" };
          }
        })
        .catch(() => {
          this.$$loading = false;
          // this.statusDisable = true;
          // this.statusCountDown = this.fixedTime;
        });
    },
    checkStatusPhonepe() {
      this.$loading = true;
      this.btnName = "check status";
      let postData = {
        url: "/payment-integration/payment-status",
        transactionId: this.phonepeData.transactionId,
      };
      let data = Object.assign(postData, this.phonepeDetails);
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          this.btnName = "";
          let code = res.data.data.code;
          if (
            code == "PAYMENT_DECLINED" ||
            code == "PAYMENT_CANCELLED" ||
            code == "PAYMENT_FAILED" ||
            code == "PAYMENT_ERROR"
          ) {
            if (code == "PAYMENT_DECLINED") {
              this.error_message = msg.PHONEPE_MSG.DECLINED;
            } else if (code == "PAYMENT_CANCELLED") {
              this.error_message = msg.PHONEPE_MSG.CANCELLED;
            } else if (code == "PAYMENT_FAILED" || code == "PAYMENT_ERROR") {
              this.error_message =
                msg.PHONEPE_MSG.SERVER_ERROR + "(" + code + ")";
            }
            this.makePayment(res.data.data, "phonepe", "error");
            this.status = { value: true, type: "cancel" };
          } else if (code == "PAYMENT_PENDING") {
            if (this.countdown < 6) {
              this.status = { value: true, type: "fail" };
            } else {
              this.alertData(msg.PHONEPE_MSG.PENDING, "success");
            }
            this.error_message = msg.PHONEPE_MSG.TIME_OUT;
          } else if (code == "PAYMENT_SUCCESS") {
            this.status = { value: true, type: "success" };
            this.makePayment(res.data.data, "phonepe", "success");
          } else if (code == "INTERNAL_SERVER_ERROR") {
            if (this.countdown < 6) {
              // this.initalTimerValue = 20;
            } else {
              this.alertData("Please try again in some time", "danger");
            }
          } else if (res.data.status == "fail") {
            this.alertData(msg.INTERNAL_SERVER_ERROR, "danger");
          }
        })
        .catch(() => {
          this.$loading = false;
          this.btnName = "";
        });
    },
    makePayment(res, org, status) {
      this.$loading = true;
      let order_id = "";
      if (this.isOfflineEnabled) {
        order_id = this.state.billing.billing.invoice_no;
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }

      let postData = {
        amount: this.amount,
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id:
          org == "phonepe"
            ? res.data.providerReferenceId
            : res.provider_reference_id,
        payment_initiate_id:
          org == "phonepe" ? res.data.transactionId : res.transaction_id,
        payment_id:
          org == "phonepe" ? res.data.transactionId : res.transaction_id,
        method: "phonepe_online",
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: status == "success" ? "" : res.code,
        status: status == "success" ? "success" : "error",
        address_id: "",
        payment_gateway_type: "PHONEPE_ONLINE",
        cash_collected: "",
        cash_return: "",
        lay_by_total: this.checkLayByAmt,
        lay_by_remark: "",
        transaction_sub_type:
          this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
        url: "save-payment",
        gateway_response:
          org == "phonepe" || org == "from_cancel"
            ? JSON.stringify(res)
            : res.id,
        payment_gateway_device_type: "",
        invoice_seq: order_id,
        remark: this.state.billing.billing.remark,
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then((res) => {
          this.$loading = false;
          if (
            this.state.billing.billing.total_payable == 0 ||
            this.state.billing.billing.total_payable == "0.00"
          ) {
            if (this.isOfflineEnabled) {
              this.$store.dispatch("billing/saveInvoiceId");
            }
            this.$store.commit("billing/resetBilling");
            this.$refs["phonepe-modal"].hide();
          } else {
            if (org == "from_cancel") {
              this.status = { value: true, type: "success" };
            }
          }
          if (res.data.status == "validation") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    closeModal() {
      this.$refs["phonepe-modal"].hide();
      this.mobile = "";
      this.$store.commit("system/clearPhonepeTransactionId");
      // this.statusDisable = true;
      // this.statusCountDown = 0;
    },
    clearMobile() {
      this.mobile = "";
      this.$nextTick(() => {
        this.$refs["mobile-input"].focus();
      });
    },
    updated(status) {
      this.countdown = status.value;
      console.log(
        (this.countdown < 95 && this.countdown > 80) ||
          (this.countdown < 50 && this.countdown > 35)
      );
      if (status.value >= 170) {
        this.statusBtnName = this.countdown - 170 + "s";
      }
      if (status.value == this.initalTimerValue - 15) {
        this.statusBtnName = "Check Status";
        this.statusDisable = false;
      }
      if (status.value == 10) {
        this.statusDisable = true;
      }
      if (status.value == 5) {
        this.checkStatusPhonepe();
      }
    },
    finished() {
      console.log("finished");
    },
    // countDown() {
    //   const interval = setInterval(() => {
    //     if (this.request) {
    //       this.statusCountDown -= 1;
    //       console.log(this.statusCountDown);
    //       if (this.statusCountDown == 0) {
    //         clearInterval(interval);
    //         this.statusDisable = false;
    //       }
    //     } else {
    //       clearInterval(interval);
    //     }
    //   }, 1000);
    // },
    alertData(msg, type) {
      let alertData = {
        message: msg,
        type: type,
      };
      this.$showAlert = true;
      this.$store.commit("notifications/showAlert", alertData);
    },
  },
};
</script>

<style lang="scss" scoped>
h6 {
  font-weight: normal;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.2s;
  max-height: 345px;
  overflow: hidden;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
}
// .bg-black {
//   background-color: #000;
//   border: 1px #606060 solid;
//   color: #fff;
// }
// .theme-light .bg-black {
//   background-color: transparent;
//   border: 1px #c0c0c0 solid;
//   color: #404040;
// }
.py-2 {
  padding-bottom: 0.8rem !important;
  padding-top: 0.8rem !important;
}
.h-25 {
  height: 40px !important;
}
.theme-dark .text-color {
  color: #c0c0c0 !important;
}
.theme-light .text-color {
  color: black !important;
}
.brand-icon:hover img {
  opacity: 0.5;
}
.blur-mobile {
  cursor: pointer;
  background: #f0f0f0;
  border: transparent;
  font-size: 12px;
}
.focus-mobile {
  cursor: pointer;
  background: #fff;
  border: 1px solid black;
  border-left: none;
  font-size: 12px;
}
.input-group input:focus {
  border: 1px solid black !important;
  border-right: none !important;
}
.confirm-btn {
  padding: 8px 32px !important;
}
.hover:hover {
  opacity: 0.6;
}
</style>
